import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updateWalletApiCall({ id, isPathDesign, walletHeader, walletDescription, walletSectionImage, walletTextAlign, sectionPadding, sectionMargin, sectionTextColor }) {
  return httpClient.put(getSectionHeadingPath(pathTypes.wallet, isPathDesign, id), {
    id,
    headingTitle: walletHeader,
    headingDescription: walletDescription,
    headingTextAlign: walletTextAlign,
    headingImage: walletSectionImage,

    sectionTextColor,
    sectionMargin,
    sectionPadding,
  });
}
